import type { SVGProps } from "react";

export default function DownloadIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.168 7.50195C15.9805 7.51204 16.9621 7.59242 17.6024 8.23274C18.3346 8.96499 18.3346 10.1435 18.3346 12.5005V13.3338C18.3346 15.6908 18.3346 16.8694 17.6024 17.6016C16.8701 18.3338 15.6916 18.3338 13.3346 18.3338H6.66797C4.31094 18.3338 3.13244 18.3338 2.4002 17.6016C1.66797 16.8694 1.66797 15.6908 1.66797 13.3338V12.5005C1.66797 10.1435 1.66797 8.96499 2.4002 8.23274C3.04052 7.59242 4.02211 7.51204 5.83464 7.50195"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M10 1.66699V12.5003M10 12.5003L7.5 9.58366M10 12.5003L12.5 9.58366"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
